export default "__VITE_ASSET__CCWaVaAj__"